import actions from './actions-shipper.js'
import mutations from './mutations-shipper.js'
import getters from './getters-shipper.js'
import state from './state-shipper.js'

export default {
    namespaced: true,
    actions,
    mutations,
    getters,
    state
}